
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Rossetti.ts;
 * Path: ./src/environments/BaseEnvironments/Rossetti.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 21/10/25, 10:15;
 * Updated at: 21/10/25, 10:15;
 *
 */

import {FullEnv as WorkFullEnv} from './Work'
import {EnvironmentModel} from "./Model";
import {CampoAggiuntivo} from "../../app/shared/models/campo-aggiuntivo";
import {Permission} from "../../app/Login/_guards/Permission";

function Env(){
  var env: EnvironmentModel = WorkFullEnv();
  env.ClientiAddOn.SezioniInfo.push(
    {
      sezione: 'Account',
      titleStyle: { 'font-weight': "700", 'padding': '0.8rem', 'background-color': 'whitesmoke' },
      campi: [
        {
          nome: "Email",
          oggetti: ["username"],
          modificabile: true,
          requiredif: { fieldexist: ['password', 'ruoliAccesso'] },
          inputType: "email",
          class: "col-lg-3"
        },
        {
          nome: "Password",
          oggetti: ["password"],
          modificabile: true,
          requiredif: { fieldexist: ['confPassword'] },
          inputType: "password",
          class: "col-lg-3"
        },
        {
          nome: "Conferma Password",
          oggetti: ["confPassword"],
          modificabile: true,
          requiredif: { fieldexist: ['confPassword'] },
          inputType: "password",
          class: "col-lg-3"
        },
        {
          nome: 'Tipo di Accesso',
          source: '/anagrafica/ruoli/list',
          responseHasData: true,
          parameter: [],
          oggetti: ['ruoliAccesso'],
          requiredif: { fieldexist: ['password', 'ruoliAccesso'] },
          internalOutput: 'ruoliAccessoObject',
          OutputField: 'ruoliAccesso',
          OnChange: 'OnruoliAccessoChange',
          modificabile: true,
          inputType: 'singleDropdown',
          placeholder: 'Seleziona',
          settings: {
            singleSelection: false,
            closeDropDownOnSelection: true,
            singleOutput: false,
            idField: 'id',
            textField: 'ruolo',
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false,
          },
          class: 'col-lg-3',
          visibleifProhibited: true
        },
      ]
    }
  )
  env.TaskAddon.DynamicFields = [...(env.TaskAddon.DynamicFields || []),
    {
      type: 'R',
      addButton: true,
      managerLoggato: {},
      hideif: { hasNotCapacity: [] },
      restRoute: '/rma/interventi',
      Label: '',
      Headers: [

      ],
      Azioni: [
      ],
      campi: [
        CampoAggiuntivo.TextField("Nome Attività", "nome", 'col-lg-12', {
          modificabile: true,

        }),
        CampoAggiuntivo.InputField("Note", "note",'textarea', 'col-lg-12', {
          modificabile: true,
        }),
        CampoAggiuntivo.InputField("Data di creazione", "data_inizio_prevista", 'datetime-local','col-lg-6', {
          modificabile: true,
        }),
        CampoAggiuntivo.InputField("In scadenza", "data_fine_prevista", 'datetime-local','col-lg-6', {
          modificabile: true,
        }),
        CampoAggiuntivo.SingleDropdown("Cliente", 'cliente', '/anagrafica/clienti/list', 'nominativo', {
          placeholder: "Seleziona il cliente",
          responseHasData:true,
          hideif:{func: (x,permission: Permission)=>permission.isntOperativeRoles(['C'])},
          parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 },
            {
              nome: "ruolo",
              value: 'C'
            },
            { nome: "nome", search: true }
          ]
        },'col-lg-4',()=>true, {
          allowRemoteDataSearch:true,
          searchPlaceholderText:'Cerca'
        }),
        CampoAggiuntivo.SingleDropdown("Responsabile", 'manager', '/anagrafica/persone/list', 'fullName', {
          placeholder: "Seleziona il responsabile",
          responseHasData:true,
          hideif:{func: (x,permission: Permission)=>permission.isntOperativeRoles(['C'])},
          parameter: [
            { nome: "page", value: 1 },
            { nome: "size", value: 200 },
            { nome: "nome", search: true }
          ]
        },'col-lg-4',()=>true, {
          allowRemoteDataSearch:true,
          searchPlaceholderText:'Cerca'
        }),
        CampoAggiuntivo.SingleDropdown("Stato", 'stato', '/rma/interventi/stati', 'label', {
        },'col-lg-4'),
        {nome: "Files", type: "Files", url:"/rma/rma/file", class: 'col-lg-12 mt-1', OnChange: 'OnFilesChange', modificabile: true}
      ]


  }]
  env.homepages= [
    {RuoliAccesso: [2], link: "/shared/dynamicedit/rmaplanner"},
  ];
  return env
}

export var environment: any = Env();
